import { Checkbox } from "@mui/material";
import React, { useState } from "react";
import { fieldRenderer } from "../Field/helper";
import { FieldType, FieldTypeType } from "../../../services/helpers/types";
import classNames from "classnames";

interface ExampleFieldProps {
  field: FieldType;
  title: string;
  titlePosition?: "left" | "top";
  defaultValue?: string;
  isSelected?: boolean;
  className?: string;
  onSelectField?: (fieldType: FieldTypeType) => void;
}

const ExampleField = (props: ExampleFieldProps) => {
  const {
    field,
    title,
    titlePosition = "left",
    defaultValue,
    isSelected,
    className,
    onSelectField,
  } = props;

  const [fieldValue, setFieldValue] = useState<string | undefined>(
    defaultValue,
  );

  const exampleClassName = classNames(
    "dui-example-field",
    {
      "dui-example-field-selected": isSelected,
      "dui-example-field-top": titlePosition === "top",
    },
    className,
  );

  return (
    <div
      className={exampleClassName}
      onClick={() => onSelectField?.(field.type)}
    >
      <div className="dui-example-field-title">
        <Checkbox className="dui-checkbox" checked={isSelected} />
        {titlePosition === "left" ? (
          <div className="dui-example-field-title-left">{title}</div>
        ) : null}
      </div>
      <div className="dui-example-field-content">
        {titlePosition === "top" ? (
          <div className="dui-example-field-title">{title}</div>
        ) : null}

        {fieldRenderer(
          field,
          (value) => {
            setFieldValue(value);
          },
          fieldValue,
        )}
      </div>
    </div>
  );
};

export default ExampleField;
